// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2_TJ2","buttons":"SendReceipts_buttons__1AtPA","email":"SendReceipts_email__1IVBg","bookApptTitle":"SendReceipts_bookApptTitle__3RibU"};